'use client';

import { CognitoUserSession } from 'amazon-cognito-identity-js';

import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState
} from 'react';

type TAuthenticationContext = {
  cognitoUser?: CognitoUserSession;
  cognitoUserEmail?: string;
  cognitoUserPassword?: string; // Have to store email and password here SEE https://github.com/aws-amplify/amplify-js/issues/6676
  setCognitoUser: Dispatch<SetStateAction<any>>;
  setCognitoUserEmail: Dispatch<SetStateAction<any>>;
  setCognitoUserPassword: Dispatch<SetStateAction<any>>;
};

const initialState = {
  cognitoUser: {} as CognitoUserSession,
  cognitoUserEmail: '',
  cognitoUserPassword: '',
  setCognitoUser: () => {},
  setCognitoUserEmail: () => {},
  setCognitoUserPassword: () => {}
};

const AuthenticationContext = createContext<TAuthenticationContext>(initialState);

const useAuthenticationContext = (): TAuthenticationContext => useContext(AuthenticationContext);

const AuthenticationProvider: FC<PropsWithChildren<unknown>> = ({ children }): JSX.Element => {
  const [cognitoUser, setCognitoUser] = useState();
  const [cognitoUserEmail, setCognitoUserEmail] = useState();
  const [cognitoUserPassword, setCognitoUserPassword] = useState();

  return (
    <AuthenticationContext.Provider
      value={{
        cognitoUser,
        setCognitoUser,
        cognitoUserEmail,
        cognitoUserPassword,
        setCognitoUserEmail,
        setCognitoUserPassword
      }}
    >
      {children}
    </AuthenticationContext.Provider>
  );
};

export { AuthenticationProvider, useAuthenticationContext };
